import { Router } from '@angular/router';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserRepositoryService } from 'src/app/services/user-repository.service';
import { subscribedNotification } from 'src/app/shared/models/notification.model';
import { User } from 'src/app/shared/models/user.model';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { NotificationFilters } from 'src/app/shared/models/notification.model';

@Component({
  selector: 'app-pending-notification',
  templateUrl: './pending-notification.component.html',
  styleUrls: ['./pending-notification.component.scss']
})
export class PendingNotificationComponent implements OnInit {
  @Input() usersInfo: User;
  @Input() notificationList: subscribedNotification[];
  @Output() onclickuploadCount = new EventEmitter();
  @Output() notificationCount = new EventEmitter();

  private unsubscribe: Subject<void> = new Subject<void>();
  notificationTag: boolean = true;
  expandPanel = false;
  panelOpenState = false;

  get hasPendingNotifications(): boolean {
    return (this.notificationList || []).some((n) => n && n.uploadCount > 0);
  }

  get hasSubscriptions(): boolean {
    return (this.notificationList || []).some((n) => n && !!n.supplierId);
  }

  constructor(private userRepositoryService: UserRepositoryService, private router:Router ) { }

  ngOnInit(): void {
  }
  saveSelectedFolder(supplierDetail:any, documentType:string){
  const selectedUserData={
      'supplierCode':supplierDetail,
      'documentType':documentType,
      
    }
    this.userRepositoryService.notoficationDocSelected.next(selectedUserData);
    this.router.navigate(['/documents'],{replaceUrl:true});
    this.onclickuploadCount.emit('close'); 
    //this.closeNotification.emit('close');
    
  }
  dismissNotification(userId,supplierId,documentTypeName){
    let dismissedNotification: NotificationFilters = {
      userId: userId,
      supplierId: supplierId,
      documentTypeName: documentTypeName
      }
    this.userRepositoryService.updateNotificationReadStatus(dismissedNotification)
    .pipe(takeUntil(this.unsubscribe))
    .subscribe((data)=>{
      this.notificationList = data.subscribedNotification;
    });

    let totalNotification: number = 0;
    this.userRepositoryService.getNotificationsInfoByUserId(this.usersInfo.cwsId)
    .pipe(takeUntil(this.unsubscribe))
    .subscribe((notificationList) => {
      
      for(var i=0; i < notificationList.subscribedNotification.length; i++){
        totalNotification += notificationList.subscribedNotification[i].uploadCount ;
      }
      this.notificationCount.emit(totalNotification);
   });
}
}
